import { createContext, useContext } from "react";
import { SnackbarMessageProps } from "./SnackbarMessage";

export type SnackbarMessagePropsExt = SnackbarMessageProps & {
  autoCloseTimeout?: number,
  autoClose?: boolean,
  key?: string,
}

export type SnackbarContextProps = {
  push: (props: SnackbarMessagePropsExt) => SnackbarMessagePropsExt,
  remove: (key: string | undefined) => void,
  clear: () => void,
}

export const SnackbarContext = createContext<SnackbarContextProps>({
  clear: () => {
    throw new Error("Not implemented");
  },
  remove: key => {
    throw new Error("Not implemented");
  },
  push: props => {
    throw new Error("Not implemented");
  },
});

export const SnackbarMessagesContext = createContext<SnackbarMessagePropsExt[]>([]);

export const useSnackbar = () => useContext(SnackbarContext);

export default SnackbarContext;

